/**
 * Date formatters for events
 */

const months = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
]

/**
 * Generates unified dates text for events with multiple days
 * @param {Array} dates - Array of event days
 * @returns {string} Formatted dates text
 */
export const generateUnifiedDates = (dates) => {
  if (!dates || dates.length === 0) return ''

  const convertedDates = dates
    .filter((date) => date.date && date.date.trim() !== '')
    .map((date) => {
      const [year, month, day] = date.date.split('-')
      return {
        date: new Date(Number.parseInt(year), Number.parseInt(month) - 1, Number.parseInt(day)),
        dayText: Number.parseInt(day)
      }
    })
    .sort((a, b) => a.date - b.date)

  if (convertedDates.length === 0) return ''

  if (convertedDates.length === 1) {
    const dateObj = convertedDates[0].date
    const day = dateObj.getDate()
    const month = months[dateObj.getMonth()]
    const year = dateObj.getFullYear()
    return `${day} de ${month} de ${year}`
  }

  const grouped = convertedDates.reduce((acc, item) => {
    const month = item.date.getMonth()
    const year = item.date.getFullYear()
    const key = `${month}-${year}`

    if (!acc[key]) {
      acc[key] = {
        month: months[month],
        year,
        days: []
      }
    }
    acc[key].days.push(item.dayText)
    return acc
  }, {})

  const groups = Object.values(grouped)

  if (groups.length === 1) {
    const group = groups[0]
    let daysText

    if (group.days.length === 1) {
      daysText = group.days[0].toString()
    } else if (group.days.length === 2) {
      daysText = `${group.days[0]} e ${group.days[1]}`
    } else {
      const lastDay = group.days.pop()
      daysText = `${group.days.join(', ')} e ${lastDay}`
    }

    return `${daysText} de ${group.month} de ${group.year}`
  }

  return convertedDates
    .map((item) => {
      const day = item.date.getDate()
      const month = months[item.date.getMonth()]
      const year = item.date.getFullYear()
      return `${day} de ${month} de ${year}`
    })
    .join(', ')
}
